var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-icon',{attrs:{"color":"success","right":""}},[_vm._v("mdi-check-circle")]):_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-alert-circle")])}
var staticRenderFns = []

export { render, staticRenderFns }